export enum EAreaPartsField {
  Area = 'area',
  Price = 'price',
  FloorFrom = 'floorFrom',
  FloorTo = 'floorTo',
  PriceType = 'priceType',
  PaymentPeriod = 'paymentPeriod',
  Photos = 'photos',
}
